import { render } from "./PotentialCustomer.vue?vue&type=template&id=6fafcb07"
import script from "./PotentialCustomer.vue?vue&type=script&lang=js"
export * from "./PotentialCustomer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__